import { ShieldCheck, Users, Zap, TrendingUp, Cpu } from "lucide-react";
import { Reveal, Chapter } from "@/components/Reveal";

const BENEFITS = [
  {
    icon: ShieldCheck,
    title: "Zero Personal Risk",
    desc: "You never put your own capital on the line beyond the initial fee. The downside sits with us.",
    stat: "Your savings stay safe",
  },
  {
    icon: Users,
    title: "Free $997/yr Mentorship",
    desc: "Instant access to working pro traders, psychology coaching, and live market calls in our Discord.",
    stat: "Included with every challenge",
  },
  {
    icon: Zap,
    title: "Rapid Payouts",
    desc: "Withdraw profits every 5 to 14 days with hassle-free KYC — only at your first payout.",
    stat: "Every 5–14 days",
  },
  {
    icon: TrendingUp,
    title: "Maximum Capital, Day One",
    desc: "Hold up to $400,000 in funded capital across multiple accounts from day one — no scaling reviews, no waiting periods.",
    stat: "Up to $400K funding",
  },
];

export default function About() {
  return (
    <section id="about" className="py-24 lg:py-32 relative" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Chapter index={1} label="Why MyFXPocket" />
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-[-0.04em] text-white max-w-3xl leading-[1.15]">
            Five years of funding, paying, and backing traders —
            <span className="gold-text"> with absolute transparency.</span>
          </h2>
          <p className="mt-5 text-base sm:text-lg text-[#999999] max-w-2xl leading-relaxed">
            Half a decade in the industry. Thousands of payouts processed. No fine print, no moving
            goalposts — just capital, technology, and a community that wants you funded.
          </p>
        </Reveal>

        <Reveal delay={0.15} className="mt-12">
          <div className="glass-card rounded-2xl p-6 sm:p-8 flex flex-col sm:flex-row items-start sm:items-center gap-6 border-l-2 border-l-[#2DACE2]">
            <div className="w-12 h-12 rounded-xl bg-[#2DACE2]/10 border border-[#2DACE2]/30 flex items-center justify-center shrink-0">
              <Cpu size={22} className="text-[#2DACE2]" />
            </div>
            <div>
              <h3 className="text-lg sm:text-xl font-semibold tracking-[-0.02em] text-white">
                Powered by Match-Trader
              </h3>
              <p className="text-sm sm:text-base text-[#999999] mt-1 leading-relaxed">
                Institutional-grade trading technology: ultra-fast execution, deep liquidity,
                seamless charting, and reliable server uptime — the same infrastructure the pros use.
              </p>
            </div>
          </div>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {BENEFITS.map((b, i) => (
            <Reveal key={b.title} delay={0.1 + i * 0.08}>
              <div className="glass-card rounded-2xl p-6 h-full group" data-testid={`benefit-card-${i}`}>
                <div className="w-11 h-11 rounded-xl bg-[#FFD700]/10 border border-[#FFD700]/25 flex items-center justify-center mb-5 transition-transform duration-300 group-hover:scale-110">
                  <b.icon size={20} className="text-[#FFD700]" />
                </div>
                <h3 className="text-lg font-semibold tracking-[-0.02em] text-white">{b.title}</h3>
                <p className="text-sm text-[#999999] mt-2 leading-relaxed">{b.desc}</p>
                <div className="mt-4 text-xs font-semibold uppercase tracking-[0.15em] text-[#FFD700]">
                  {b.stat}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
